import DevExpress from "devextreme/bundles/dx.all";

export class AdminGridColumnsFactory {
  static createTextColumn<T>(
    options: {
      fieldName: keyof T;
      caption: string;
      cssClass?: string;
    },
    otherOptions?: DevExpress.ui.dxDataGrid.Column
  ): DevExpress.ui.dxDataGrid.Column {
    return {
      dataType: "string",
      dataField: options.fieldName as string,
      cssClass: options.cssClass,
      caption: options.caption,
      minWidth: 100,
      ...otherOptions
    };
  }

  static createLookupColumn<T>(
    options: {
      fieldName: keyof T;
      cssClass?: string;
      minWidth?: number;
      caption: string;
      lookup: {
        allowClearing?: boolean;
        dataSource: unknown[];
        displayExpr?: string;
        valueExpr?: string;
      };
    },
    otherOptions?: DevExpress.ui.dxDataGrid.Column
  ): DevExpress.ui.dxDataGrid.Column {
    const valueExpr = options.lookup.valueExpr || "id";
    const displayExpr = options.lookup.displayExpr || "name";
    return {
      dataField: options.fieldName as string,
      caption: options.caption,
      cssClass: options.cssClass,
      minWidth: options.minWidth,
      lookup: {
        allowClearing: options.lookup.allowClearing,
        displayExpr,
        valueExpr,
        dataSource: options.lookup.dataSource
      },
      ...otherOptions
    };
  }

  static createDateTimeColumn<T>(
    options: {
      fieldName: keyof T;
      caption: string;
      cssClass?: string;
    },
    otherOptions?: DevExpress.ui.dxDataGrid.Column
  ): DevExpress.ui.dxDataGrid.Column {
    return {
      dataType: "datetime",
      dataField: options.fieldName as string,
      cssClass: options.cssClass,
      caption: options.caption,
      minWidth: 150,
      width: 180,
      format: "MM/dd/yyyy",
      ...otherOptions
    };
  }

  static createButtonsColumn(
    options: {
      buttons: DevExpress.ui.dxDataGrid.ColumnButton[];
      caption?: string;
      cssClass?: string;
      name?: string;
    },
    otherOptions?: DevExpress.ui.dxDataGrid.Column
  ): DevExpress.ui.dxDataGrid.Column {
    return {
      type: "buttons",
      name: options.name ?? "buttons",
      cssClass: options.cssClass,
      caption: options.caption,
      minWidth: 100,
      buttons: options.buttons,
      width: "auto",
      ...otherOptions
    };
  }

  static createCheckboxColumn<T>(
    options: {
      fieldName: keyof T;
      caption: string;
    },
    otherOptions?: DevExpress.ui.dxDataGrid.Column
  ): DevExpress.ui.dxDataGrid.Column {
    return {
      dataType: "boolean",
      dataField: options.fieldName as string,
      caption: options.caption,
      width: 100,
      ...otherOptions
    };
  }

  static createSelectionColumn(): DevExpress.ui.dxDataGrid.Column {
    return {
      type: "selection"
    };
  }
}
